import { useRef } from "react";

import { twMerge } from "@/utils/twMerge";
import { useRovingNav } from "@/utils/useRovingNav";

import type { ComponentProps } from "react";

/**
 * A row of sidebar buttons as one Tab stop: the arrow keys along it move between its buttons and
 * links. It runs vertical in a collapsed sidebar, where Up/Down move focus instead of opening the
 * menus behind its menu buttons, which still open with Enter or Space.
 */
export function SidebarToolbar({
  label,
  vertical = false,
  className,
  children,
  ...props
}: ComponentProps<"div"> & { label: string; vertical?: boolean }) {
  const toolbarRef = useRef<HTMLDivElement>(null);
  const orientation = vertical ? "vertical" : "horizontal";
  useRovingNav(toolbarRef, orientation, {
    itemSelector: "a[href], button:not(:disabled)",
    capture: true,
  });

  return (
    <div
      ref={toolbarRef}
      role="toolbar"
      aria-orientation={orientation}
      aria-label={label}
      className={twMerge("flex", vertical && "flex-col", className)}
      {...props}
    >
      {children}
    </div>
  );
}
